$( document ).ready(function() {
    $('select.js-single-option-selector').on('change', function() {
      console.log('changed')
      let currentValue = this.value;
      $(".js-single-option-selector--custom[value='"+currentValue+"']").prop("checked",true);
    });
  $('.js-single-option-selector--custom').on('click', function() {
      let currentValue = $(this).attr('value');
     $("select.js-single-option-selector option[value='"+currentValue+"']").prop('selected', 'selected').change();

  });

  // For sticky
    $(document).on('change', 'select.select_variants', function() {
    
    let currentOPrice = $('option:selected', this).attr('variant_price');
    let currentImage = $('option:selected', this).attr('variant_image');
    
    let currentCPrice = $('option:selected', this).attr('variant_price-compare');
    $(this).closest('.custom--upsell-item-details').find('.upsell-original--price').html(currentOPrice);
    $(this).closest('.custom--upsell-item-details').find('.upsell-compare--price').html(currentCPrice);
    $(this).closest('.custom--upsell-item-details').prev('.custom--upsell-item-img').find('img').attr('src', currentImage);
    
    });
});

// LOGO MARQUEE
$('.logo_marquee_slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4,
      }
    },
  ]
});
// END :: LOGO MARQUEE

// START :: ANNOUNCEMENT SLIDER 

$('.announcement_slider').slick({
  draggable: true,
  arrows: false,
  autoplay: true,
  dots: false,
  fade: true,
  speed: 900,
  infinite: true,
  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
  touchThreshold: 100
})

// END :: ANNOUNCEMENT SLIDER


$(document).ready(function () {
  const productId = 54859742904695; // Protection product ID
  const newProductId = 56141369999735;

  // Function: go to checkout
  function goToCheckout() {
    window.location.href = "/checkout";
  }
  
  $(document).on("click", ".btn--checkout", function(e){
    if (theme.cart.item_count >= 1) {
      e.preventDefault();
      goToCheckout();
    }
  });

  // Function: add product if not already in cart
  function addProductAndCheckout() {
    // $.getJSON('/cart.js', function(cart) {
    //   const exists = cart.items.some(item => item.id === productId);
    //   if (exists) {
    //     goToCheckout();
    //   } else {
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/add.js',
    //       data: JSON.stringify({
    //         id: productId,
    //         quantity: 1,
    //         properties: {
    //           "_type": "shipping_product"
    //         }
    //       }),
    //       dataType: 'json',
    //       contentType: 'application/json',
    //       success: function () {
    //         goToCheckout();
    //       }
    //     });
    //   }
    // });
    $.getJSON('/cart.js', function(cart) {
      const itemsToAdd = [];

      // Check Protection Product
      const hasProtection = cart.items.some(item => item.id === productId);
      if (!hasProtection) {
        itemsToAdd.push({
          id: productId,
          quantity: 1,
          properties: { "_type": "shipping_product" }
        });
      }

      // Check New Product
      const hasNewProduct = cart.items.some(item => item.id === newProductId);
      if (!hasNewProduct) {
        itemsToAdd.push({
          id: newProductId,
          quantity: 1,
          properties: { "_type": "import_text_product" }
        });
      }

      // If nothing new to add, go to checkout
      if (itemsToAdd.length === 0) {
        goToCheckout();
        return;
      }

      // Add all missing products at once
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: itemsToAdd }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          goToCheckout();
        }
      });
    });
  }

  // Function: remove product if exists
  function removeProductAndCheckout() {
    $.getJSON('/cart.js', function(cart) {
      const item = cart.items.find(i => i.id === productId);
      console.log("item--->", item)
      if (item) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: item.key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            goToCheckout();
          }
        });
      } else {
        goToCheckout();
      }
    });
  }

  // Checkout button click
  // $(document).on("click", ".btn--checkout", function(e){
  //   console.log("innnnn");

  //   if (theme.cart.item_count == 1) {
  //     console.log("cart", theme.cart.items[0].title);

  //     if (theme.cart.items[0].title == '24H PRIORITY PROCESSING') {
  //       alert("You can't checkout with this product");
  //       $(this).removeClass('btn--loading').removeAttr('disabled');
  //       e.preventDefault();
  //     } else {
  //       e.preventDefault();
  //       addProductAndCheckout();
  //     }
  //   } 
  //   else {
  //     e.preventDefault();
  //     addProductAndCheckout();
  //   }
  });

  // "Checkout without package protection" link
  $(document).on("click", "a.without_protection", function(e) {
    e.preventDefault();
    removeProductAndCheckout();
  });

// Product Trust Badges Start
  $(".ptb-item-wrapper").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      arrows: false,
      dots: false,
      cssEase: "linear",
      variableWidth: true,
      responsive: [
          {
              breakpoint: 1240,
              settings: {
                  slidesToShow: 5,
                  slidesToScroll: 1,
              },
          },
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
              },
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
              },
          },
      ],
  });
// Product Trust Badges End

// FAQ HOME -- START
  $(document).ready(function () {
    $(".home-set > a").on("click", function (e) {
      e.preventDefault();

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".home-content").slideUp(200);
        $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
      } else {
        $(".home-set > a").removeClass("active");
        $(".home-content").slideUp(200);
        $(".home-set > a i").removeClass("fa-minus").addClass("fa-plus");

        $(this).addClass("active");
        $(this).siblings(".home-content").slideDown(200);
        $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      }
    });
  });
// FAQ HOME -- END

// SOCIAL MEDIA SCROLL -- START
  $(".social-media-scrollbar").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    arrow:false,
    dots:false,
    speed: 8000,
    pauseOnHover: false,
    infinite: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
// SOCIAL MEDIA SCROLL -- END


jQuery(document).on('click', '.custom_bundle_item', function () {
  // Remove active from all items
  jQuery('.custom_bundle_item').removeClass('active');

  // Add active to clicked item
  jQuery(this).addClass('active');
});

jQuery(document).on('change', '.cp_color_select', function(){
  var selVal = $(this).val();
  if($('.custom_bundle_block').find('.custom_bundle_item.active').length){
    var budnelActive = $('.custom_bundle_block').find('.custom_bundle_item.active');
    $(this).parent('.cb_listing_item').find('.cp_size_select').removeClass('active');
    $(this).parent('.cb_listing_item').find('.cp_size_select').hide();
    $(this).parent('.cb_listing_item').find('.bun_pro_'+selVal).addClass('active');
    $(this).parent('.cb_listing_item').find('.bun_pro_'+selVal).show();
  }
});

// PRODUCT KEY HIGHLIGHT - START
document.addEventListener("DOMContentLoaded", function () {
  const rechargeWidget = document.querySelector('.recharge-subscription-widget .rc-widget');
  const productHighlights = document.querySelector('.product_key_highlights');

  if (!productHighlights) return;

  if (rechargeWidget) {
    productHighlights.style.display = 'block';
  } else {
    productHighlights.style.display = 'none';
  }
});

(function () {
  function handleToggle(onetimeRadio) {
    const highlights = document.querySelector(".product_key_highlights");
    if (!highlights) return;
    if (onetimeRadio.classList.contains("rc-radio--active")) {
      highlights.style.display = "none";
    } else {
      highlights.style.display = "block";
    }
  }
  const globalObserver = new MutationObserver(() => {
    const onetimeRadio = document.querySelector(
      ".recharge-subscription-widget .onetime-radio"
    );
    if (!onetimeRadio) return;
    handleToggle(onetimeRadio);

    const classObserver = new MutationObserver(() => {
      handleToggle(onetimeRadio);
    });

    classObserver.observe(onetimeRadio, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
  globalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
// PRODUCT KEY HIGHLIGHT - END


// PRODUCT CUSTOM REVIEW BADGE - START
if (!window.__reviewBadgeSmoothScrollInit) {
  window.__reviewBadgeSmoothScrollInit = true;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.review-badge__link');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#' || href.length < 2) return;

    e.preventDefault();

    var target = document.getElementById(href.slice(1)) || document.querySelector(href);
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}
// PRODUCT CUSTOM REVIEW BADGE - END